import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianHospitalNameFieldController extends GeneralTreatingPhysicianFieldController {}
